<template>
  <ComicBookComponent />
</template>

<script>
import ComicBookComponent from "../components/Book/ComicsBookComponent";

export default {
  name: "ComicBook",
  components: {
    ComicBookComponent,
  },
};
</script>

<style scoped>
</style>
